import './App.css';
import { useState, useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@mui/material/Button';

import HomeIcon from '@mui/icons-material/Home';
import BrushIcon from '@mui/icons-material/Brush';
import ComputerIcon from '@mui/icons-material/Computer';
import CasinoIcon from '@mui/icons-material/Casino';
import KitchenIcon from '@mui/icons-material/Kitchen';


import Home from './components/Home/Home.js';
import Hobbies from './components/Hobbies/Hobbies.js';
import WebDev from './components/WebDev/WebDev.js';
// import DnD from './components/DnD/DnD.js';
// import Kitchen from './components/Kitchen/Kitchen.js';

function App() {

  const [homePage, setHomePage] = useState(true)
  const [hobbyPage, sethobbyPage] = useState(false)
  const [webDevPage, setWebDevPage] = useState(false)
  const [dnDPage, setDnDPage] = useState(false)
  const [kitchenPage, setKitchenPage] = useState(false)

  useEffect(() => {
    if (window.location.pathname === "/manifesto") {
      switchHobbyPage(true);
    }
  }, []);


  const switchHomePage = () => {
    scrollToTop();
    setDnDPage(false);
    setHomePage(true);
    sethobbyPage(false);
    setWebDevPage(false);
    setKitchenPage(false);
  }

  const switchHobbyPage = () => {
    scrollToTop();
    setDnDPage(false);
    setHomePage(false);
    sethobbyPage(true);
    setWebDevPage(false);
    setKitchenPage(false);
  }

  const switchWebDevPage = () => {
    scrollToTop();
    setDnDPage(false);
    setHomePage(false);
    sethobbyPage(false);
    setWebDevPage(true);
    setKitchenPage(false);
  }

  const switchDnDPage = () => {
    scrollToTop();
    setDnDPage(true);
    setHomePage(false);
    sethobbyPage(false);
    setWebDevPage(false);
    setKitchenPage(false);
  }

  
  const switchKitchenPage = async () => {
    scrollToTop();
    setDnDPage(false);
    setHomePage(false);
    sethobbyPage(false);
    setWebDevPage(false);
    setKitchenPage(true);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  return (
    <div className="app">
      <AppBar style={{ zIndex: 1000, backgroundColor: "black", height: "5em" }}>
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          {/* <div> */}
            {/* <Button title="Coming Soon in 2026! No more pantry checks or grocery lists every time you cook or shop!"
             onClick={() => switchKitchenPage()}
             onClick={() => alert("Coming Soon in 2026! No more pantry checks or grocery lists every time you cook or shop!")}
              ><Typography style={kitchenPage ? { color: "gray" } : { color: "white" }} className="navBarButtons coming-soon" >
              <span className="navbar-icon"><KitchenIcon></KitchenIcon></span>
              <span className="navbar-text">No More Pantry</span>
            </Typography></Button> */}
            {/* <Button title="Coming Soon in 2026! Want to dip your toe in D&D but don't have the group for it?"
             onClick={() => switchDnDPage()}
             onClick={() => alert("Coming Soon in 2026! Want to dip your toe in D&D but don't have the group for it?")}
            ><Typography style={dnDPage ? { color: "gray" } : { color: "white" }} className="navBarButtons coming-soon" >
              <span className="navbar-icon"><CasinoIcon></CasinoIcon></span>
              <span className="navbar-text">Solo D&D</span>
            </Typography></Button> */}
            {/* <Button onClick={() => switchWebDevPage()}><Typography style={webDevPage ? { color: "gray" } : { color: "white" }} className="navBarButtons" >
              <span className="navbar-icon"><ComputerIcon></ComputerIcon></span>
              <span className="navbar-text">web-dev</span>
            </Typography></Button> */}
          {/* </div> */}
          <div>
            <Button onClick={() => switchHomePage()}><Typography style={homePage ? { color: "gray" } : { color: "white" }} className="navBarButtons" >
              <span className="navbar-icon"><HomeIcon></HomeIcon></span>
              <span className="navbar-text">home</span>
            </Typography></Button>
            <Button onClick={() => switchHobbyPage()}><Typography style={hobbyPage ? { color: "gray" } : { color: "white" }} className="navBarButtons" >
              <span className="navbar-icon"><BrushIcon></BrushIcon></span>
              <span className="navbar-text">art</span>
            </Typography></Button>
          </div>
        </Toolbar>
      </AppBar>
      <div style={{ height: "5em" }} ></div>
      {
        homePage &&
        <div>
          <Home />
          <WebDev />
        </div>
      }
      {
        hobbyPage &&
        <Hobbies />
      }
      {/* {dnDPage &&
        <DnD />
      }
      {kitchenPage &&
        <Kitchen />
      } */}
      <footer className="bottom">mahmudbennbaia@gmail.com</footer>
    </div>
  );
}

export default App;